import { RowData } from "./types";
import { getValueWithCurrency } from "@/components/Common/Currency";

export const grossPurchaseAmountCellValueGetter = ({ data }: { data: RowData }) => {
    if ("balance" in data) {
        return null;
    }

    const { amount } = data.item.purchase;

    return amount ? amount : null;
};

export const GrossPurchaseAmountCellFormatter = ({ data }: { data: RowData }) => {
    if ("grossPurchaseAmount" in data) {
        const { currency, grossPurchaseAmount } = data;
        return getValueWithCurrency(grossPurchaseAmount, currency);
    }

    if (!data.isOrganizer) {
        return "";
    }

    const {
        amount,
        purchase: { currency },
    } = data.item;

    return getValueWithCurrency(amount, currency);
};
